import React from "react";
import { Card } from "@material-ui/core";
import styled from "styled-components";
import { FiWind } from "react-icons/fi";
import { IoMoonOutline, IoSunnyOutline } from "react-icons/io5";
import { useHistory } from "react-router";
const StyledCard = styled(Card)`
	position: relative;
	max-width: 500px;
	width: 100%;
	margin-left: 50px;
	-webkit-box-shadow: 0px 0px 9px 4px #000000;
	box-shadow: 0px 0px 9px 4px #000000;
	margin-bottom: 20px;
	background-image: url(${(props) => props.image});
	background-size: cover;
	text-align: center;
	color: ${(props) => props.color} !important;
	&:hover {
		cursor: pointer;
	}
	span {
		font-size: 30px;
	}
	div {
		div {
			display: flex;
			justify-content: center;
			align-items: center;
			p {
				margin-right: 4px;
			}
		}
	}
`;

const IconContainer = styled.span`
	position: absolute;
	top: 20px;
	left: 20px;
`;

const ItemLocation = (props) => {
	const history = useHistory();
	const handleClick = () => {
		history.push(`/${props.element.location.name}`);
	};
	return (
		<StyledCard
			onClick={handleClick}
			image={props.backgroundImage}
			color={props.element.current.is_day === 1 ? "black" : "white"}
		>
			<IconContainer>
				{props.element.current.is_day === 1 ? (
					<IoSunnyOutline />
				) : (
					<IoMoonOutline />
				)}
			</IconContainer>
			<div>
				<h1>{props.element.location.name}</h1>
				<p>{props.element.current.condition.text}</p>
				<span>{props.element.current.temp_c} ºC</span>
				<div>
					<p>{props.element.current.wind_kph} kmh</p>
					<FiWind />
				</div>
			</div>
		</StyledCard>
	);
};

export default ItemLocation;
